function toChildrenArray(children) {
    if (!children) {
        return [];
    }
    return Array.isArray(children) ? children : [];
}

export function normalizeHierarchyNode(node, depth = 0) {
    if (!node || typeof node !== "object") {
        return null;
    }

    const currentDepth = node.depth ?? depth;
    const rawChildren = toChildrenArray(node.children);
    const children = normalizeHierarchyChildren(rawChildren, currentDepth + 1);

    return {
        id: node.tenant_code,
        label: node.tenant_name || node.tenant_dir,
        tenant_code: node.tenant_code,
        tenant_dir: node.tenant_dir,
        tenant_name: node.tenant_name,
        depth: currentDepth,
        children,
        isLeaf: children.length === 0,
    };
}

export function normalizeHierarchyChildren(nodes, depth = 0) {
    if (!Array.isArray(nodes) || !nodes.length) {
        return [];
    }

    return nodes
        .map((node) => normalizeHierarchyNode(node, depth))
        .filter(Boolean);
}

export function normalizeHierarchyTreeFromRoot(treeRoot) {
    if (!treeRoot || typeof treeRoot !== "object") {
        return [];
    }

    const rootNode = normalizeHierarchyNode(treeRoot, treeRoot.depth ?? 0);
    return rootNode ? [rootNode] : [];
}
